import $ from 'jquery';

export default function PermissionGroup(vm) {
    this.all = function(params) {
        var url = '/permission-group/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/permission-group/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/permission-group/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = '/permission-group/delete/' + params.id;

        return vm.delete(url);
    };
}